/**
 * Rapor'un alt başlıkları, sol menüde Rapor'un altında (kullanıcı, 11 Eki
 * 2026). Boş = genel bakış (kartlar ve grafikler); ötekiler o günün ayrıntısı,
 * kendi sayfasında.
 */
export const REPORT_SECTIONS: [string, string][] = [
  ['urunler', 'Ürün Satışları'],
  ['siparisler', 'Siparişler'],
  ['gelismis', 'Gelişmiş Rapor'],
]
